import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  TextField,
  Card,
  CardContent,
  Typography,
  Box,
  Table,
  Button,
  Grid,
} from "@mui/material";
import { Link } from "react-router-dom";
import axios from "axios";
import useFetch from "../utils/UseFetch";
import { useNavigate, useLocation } from "react-router-dom";
import {
  token,
  prequalificationheader,
  prequalificationheaderNoCompany,
  submitPrequalification,
} from "../HelperFx/datalinks";
import { base64ToBlob, convertFileToBase64 } from "../HelperFx/common.js";
import PrequalificationLines from "./PrequalificationLines.jsx";
import Swal from "sweetalert2";
import { Row, Col } from "reactstrap";

const eq = " eq ";

const REACT_APP_COMPANY = process.env.REACT_APP_COMPANY;
const REACT_APP_API_DATA_URL = process.env.REACT_APP_API_DATA_URL;

const REACT_DATA_URL = REACT_APP_API_DATA_URL;
const REACT_APP_COMPANY_URL = REACT_APP_COMPANY;

const Prequalification = () => {
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState([]);
  const [newSelectedFile, setNewSelectedFile] = useState([]);
  const fileInputRef = useRef(null);
  const location = useLocation();
  const preqNo = location?.state?.PreqNo || "";

  const {
    data: itemsLines,
    loading,
    error,
  } = useFetch(`${prequalificationheader}&$filter=no${eq}'${preqNo}'`, token);

  const [formData, setFormData] = useState({
    SystemId: "",
    no: "",
    requestdate: "",
    description: "",
    relatedpartyType: "",
    relatedpartyNo: "",
    status: "",
  });

  // Populate initial state from API
  useEffect(() => {
    if (itemsLines?.value?.length > 0) {
      setFormData(itemsLines.value[0]);
    }
  }, [itemsLines]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Update field on blur
  const handleBlur = async (e) => {
    const { name, value } = e.target;

    // Only update description
    if (name !== "description") return;

    try {
      await axios.patch(
        `${prequalificationheaderNoCompany}(${formData.SystemId})?${REACT_APP_COMPANY}`,
        { [name]: value },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${token}`,
            "If-Match": "*",
          },
        }
      );
      console.log(`Field "${name}" updated to "${value}"`);
    } catch (err) {
      console.error("Error updating field:", err);
    }
  };

  const makeAttachment = async (file, documentNo) => {
    // setIsModalLoading(true);
    if (!file) {
      Swal.fire("Error", "No file to Attach");
      // setIsModalLoading(false);
      return;
    }

    const fileContent = await convertFileToBase64(file);
    const fext = file.name;
    console.log("File extension:", fext); // Debug log

    const body = {
      FileName: file.name,
      fileType: fileContent.type,
      FileExtension: file.name.split(".").pop(),
      FileContentBase64: fileContent.split(",")[1],
      TableID: 50339,
      No: documentNo,
    };
    try {
      const response = await axios.post(
        `${REACT_DATA_URL}documentAttachments?${REACT_APP_COMPANY_URL}`,
        body,
        {
          headers: { Authorization: `Basic ${token}` },
        }
      );
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Clear the file input
      }
      // setNewSelectedFile([]);
      setNewSelectedFile([]);
      await getDocumentAttachments(documentNo);
      console.log("Attachment response:", response.data); // Debug log
      Swal.fire("Success", "File attached successfully");
    } catch (error) {
      console.error("Error attaching file:", error);
      Swal.fire("Error", "Failed to attach file", "error");
    } finally {
      // setIsModalLoading(false);
    }
  };
  const submitDocument = async (documentNo) => {
    if (!documentNo) return;
    Swal.fire({
      title: `<span style="font-size:1.1rem">Do you want to Submit the Prequalification for further processing?</span>`,
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(submitPrequalification, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Basic ${token}`,
            },
            body: JSON.stringify({ no: documentNo }),
          });
          if (response.ok) {
            Swal.fire(
              "Prequalification submitted successfuly!",
              "",
              "success"
            ).then(() => {
              window.location.reload();
            });
          } else {
            Swal.fire("Error!", response.statusText, "error");
          }
        } catch (error) {
          console.error("Error Submiting Prequalification:", error);
          Swal.fire("Error!", "Failed to submit Prequalification", "error");
        }
      } else if (result.isDismissed) {
        Swal.fire("Prequalification Submission cancelled", "", "info");
      }
    });
  };

  const getDocumentAttachments = async (documentNo) => {
    // setIsModalLoading(true);
    setNewSelectedFile((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles.splice(0);
      return updatedFiles;
    });

    try {
      const response = await axios.get(
        `${REACT_DATA_URL}documentAttachments?${REACT_APP_COMPANY_URL}&$filter=No eq '${documentNo}' and TableID eq 50339`,
        {
          headers: { Authorization: `Basic ${token}` },
        }
      );
      console.log("Attachments:", response.data); // Debug log
      setSelectedFile(response.data.value);
      setNewSelectedFile([]);
    } catch (error) {
      console.error("Error fetching attachments:", error);
      Swal.fire("Error", "Failed to load attachments", "error");
    } finally {
      // setIsModalLoading(false);
    }
  };
  const downloadAttachment = async (systemId) => {
    // setIsModalLoading(true);
    try {
      const response = await axios.get(
        `${REACT_DATA_URL}documentAttachments(${systemId})?${REACT_APP_COMPANY_URL}`,
        {
          headers: { Authorization: `Basic ${token}` },
        }
      );
      // console.log('Attachment response:', response.data.FileName); // Debug log
      const ext = response.data?.FileExtension;
      const blob = base64ToBlob(response.data?.FileContentBase64, ext);
      // console.log(blob);
      // console.log(ext);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${systemId}.${ext}`; // Set the desired file name
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading attachment:", error);
    } finally {
      // setIsModalLoading(false);
    }
  };

  const removeAttachment = (systemId, documentNo) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // setIsModalLoading(true)
        axios
          .delete(
            `${REACT_DATA_URL}documentAttachments(${systemId})?${REACT_APP_COMPANY_URL}`,
            {
              headers: {
                Authorization: `Basic ${token}`,
              },
            }
          )
          .then((r) => {
            getDocumentAttachments(documentNo);
            // setIsModalLoading(false);
          })
          .catch((e) => {
            // setIsModalLoading(e)
          });
      }
    });
  };
  const handleSelectedFiles = (e) => {
    const files = e.target.files;
    setNewSelectedFile(Array.from(files));
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 2, ml: 0 }}>
      <Box sx={{ display: "flex", mb: 2 }}>
        <Button
          variant="contained"
          size="small"
          onClick={() => navigate(-1)}
          sx={{
            whiteSpace: "nowrap",
            backgroundColor: "#844646ff",
            px: 3,
            py: 1.5,
            mr: 2,
          }}
        >
          Back
        </Button>

        <Button
          variant="contained"
          size="small"
          onClick={() => submitDocument(location.state?.PreqNo)}
          sx={{
            px: 3,
            py: 1.5,
            backgroundColor: "#844646ff",
            px: 3,
            py: 1.5,
            mr: 2,
          }}
        >
          Submit
        </Button>
        <Button
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          size="small"
          variant="contained"
          sx={{
            whiteSpace: "nowrap",
            backgroundColor: "#844646ff",
            px: 3,
            py: 1.5,
          }}
          onClick={() => getDocumentAttachments(location.state?.PreqNo)}
        >
          Attach
        </Button>
      </Box>

      {/* {attShow && ( */}
      <div
        className="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Attachments
              </h5>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
            <div className="modal-body">
              <Row className="mb-2">
                <Col md={6} sm={12}>
                  <div className="mb-3">
                    <label htmlFor="floatingnameInput" className="mb-1">
                      Attach File
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={(e) => handleSelectedFiles(e)}
                      ref={fileInputRef}
                    />
                  </div>
                </Col>
                <Col md={4}></Col>
                <Col md={2} sm={12}>
                  <a
                    href="#15"
                    className="btn btn-sm border-black action-btn mt-4"
                    onClick={(e) => {
                      e.preventDefault();
                      makeAttachment(newSelectedFile[0], preqNo);
                    }}
                  >
                    Attach
                  </a>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={12}>
                  {selectedFile.length > 0 || newSelectedFile.length > 0 ? (
                    <div className="table-responsive">
                      <Table className="table table-striped table-sm mb-4">
                        <thead>
                          <tr>
                            <th>No</th>
                            <th>File</th>
                            <th>Remove</th>
                          </tr>
                        </thead>
                        <tbody>
                          {newSelectedFile.map((a, k) => (
                            <tr key={k}>
                              <td style={{ verticalAlign: "middle" }}>
                                {k + 1}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {a.name}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                <div className="d-flex gap-3">
                                  {/* <Link
                                                        to="#"
                                                        className="text-danger"
                                                        // onClick={() => removeFile(k)}
                                                    >
                                                        Remove
                                                    </Link> */}
                                </div>
                              </td>
                            </tr>
                          ))}
                          {selectedFile.map((a, k) => (
                            <tr key={k} className="py-1">
                              <td style={{ verticalAlign: "middle" }}>
                                {k + 1}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                <Link
                                  to="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    downloadAttachment(a.SystemId);
                                  }}
                                >
                                  {a.FileName}
                                </Link>
                              </td>
                              <td
                                style={{
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                {" "}
                                <>
                                  <div className="d-flex gap-3">
                                    <Link
                                      to="#10"
                                      className="text-danger"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        removeAttachment(a.SystemId, a.no);
                                      }}
                                    >
                                      Remove
                                    </Link>
                                  </div>
                                </>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  ) : (
                    <div className="text-center">
                      <div className="mb-4">
                        <i className="mdi mdi-file-question text-warning display-4" />
                      </div>
                      <h6>No file attached</h6>
                    </div>
                  )}
                </Col>
              </Row>
            </div>
            <div className="modal-footer">
              {/* <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
              {/* <button type="button" class="btn btn-primary">Save changes</button> */}
            </div>
          </div>
        </div>
      </div>

      {loading && <Typography>Loading...</Typography>}
      {error && <Typography color="error">Error: {error.message}</Typography>}

      {!loading && (
        <Card sx={{ p: 1 }}>
          <CardContent>
            <Grid container spacing={1}>
              {Object.keys(formData)
                .filter(
                  (field) =>
                    field !== "SystemId" &&
                    field !== "relatedpartyNo" &&
                    field !== "@odata.etag"
                ) // hide SystemId + relatedpartyNo
                .map((field) => (
                  <Grid item xs={12} sm={6} lg={4} key={field}>
                    <TextField
                      name={field}
                      label={field}
                      value={formData[field] || ""}
                      size="small"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      margin="normal"
                      fullWidth
                      disabled={
                        formData.status === "Sent" || field !== "description"
                      }
                    />
                  </Grid>
                ))}
            </Grid>
          </CardContent>
        </Card>
      )}
      <PrequalificationLines docNo={preqNo} Status={formData.status} />
    </Container>
  );
};

export default Prequalification;
